export const colors = {
  black: '#000000',
  white: '#ffffff',

  gray10: '#F9FAFA',
  gray20: '#F6F7F7',
  gray30: '#EFF0F0',
  gray50: '#E2E5E6',
  gray80: '#D0D4D6',
  gray100: '#C6CBCD',
  gray150: '#BDC2C5',
  gray200: '#B3BABD',
  gray250: '#AAB1B5',
  gray300: '#A1A9AD',
  gray400: '#878F91',
  gray450: '#80878A',
  gray500: '#707679',
  gray550: '#606567',
  gray600: '#505456',
  gray700: '#393B3D',
  gray800: '#292B2B',
  gray900: '#1F2020',
  gray950: '#181818',
  gray970: '#121212',
  gray990: '#050505',

  red50: '#FFF0F0',
  red100: '#FFD6D6',
  red150: '#FFADAD',
  red200: '#FF8484',
  red300: '#FF5B5B',
  red400: '#FF3333',
  red500: '#E52D2D',
  red600: '#BF2626',
  red700: '#991E1E',
  red800: '#731717',
  red900: '#4C0F0F',
  red950: '#2E0909',

  orange50: '#FFF6EB',
  orange100: '#FFE3BD',
  orange150: '#FFCE8C',
  orange200: '#FFBA5E',
  orange300: '#FFA733',
  orange400: '#FF8C00',
  orange500: '#E58300',
  orange600: '#CC7400',
  orange700: '#995700',
  orange800: '#7F4900',
  orange900: '#543000',
  orange950: '#321D00',

  yellow50: '#FFFAE5',
  yellow100: '#FFF0B2',
  yellow150: '#FFE98F',
  yellow200: '#FFE166',
  yellow300: '#FFD733',
  yellow400: '#FFCD00',
  yellow500: '#E8BB00',
  yellow600: '#CCA400',
  yellow700: '#B28F00',
  yellow800: '#947700',
  yellow900: '#665200',
  yellow950: '#322800',

  green100: '#F2FAF4',
  green200: '#C8EBD3',
  green300: '#91D6A7',
  green400: '#5AC27C',
  green500: '#23AE50',
  green600: '#209D48',
  green700: '#1C8B40',
  green800: '#197A38',
  green900: '#156830',

  light_blue50: '#F0FAFF',
  light_blue100: '#E1F4FE',
  light_blue200: '#B3E3FD',
  light_blue300: '#81D1FB',
  light_blue400: '#51BEF7',
  light_blue500: '#32B0F5',
  light_blue600: '#23A2F2',
  light_blue700: '#2294E3',
  light_blue800: '#2182CE',
  light_blue900: '#1E71BA',

  blue50: '#F5F6FF',
  blue100: '#EDF0FE',
  blue200: '#C8D2FD',
  blue300: '#A3B4FB',
  blue400: '#7E96F9',
  blue500: '#4769F7',
  blue600: '#405EDE',
  blue700: '#324AAD',
  blue800: '#2B3F94',
  blue900: '#1C2A63',

  purple50: '#F5F5FF',
  purple100: '#E8E6FF',
  purple150: '#D7D4FF',
  purple200: '#C0BAFF',
  purple300: '#A89FFF',
  purple400: '#8F82FF',
  purple500: '#7463F2',
  purple600: '#604EDF',
  purple700: '#4B3ABF',
  purple800: '#392C99',
  purple900: '#29206E',

  zigzag_pink100: '#FFEBF5',
  zigzag_pink200: '#FFC2E1',
  zigzag_pink300: '#FF99CE',
  zigzag_pink400: '#FF71BA',
  zigzag_pink500: '#FF349C',
  zigzag_pink600: '#E62F8C',
  zigzag_pink700: '#C0176D',
  zigzag_pink800: '#8F074D',
  zigzag_pink900: '#610032',

  zigzag_pink_new50: '#FEF6FD',
  zigzag_pink_new100: '#FFEBFC',
  zigzag_pink_new150: '#FFD1F7',
  zigzag_pink_new200: '#FFB2F3',
  zigzag_pink_new300: '#FF8AEB',
  zigzag_pink_new400: '#FA6EE3',
  zigzag_pink_new500: '#E560CF',
  zigzag_pink_new600: '#BF49AB',
  zigzag_pink_new700: '#913382',
  zigzag_pink_new800: '#6D2261',
  zigzag_pink_new900: '#4F1245',
};
